module.exports = require("domurl");


//////////////////
// WEBPACK FOOTER
// external "domurl"
// module id = 8
// module chunks = 0 1